@if (isV2()) {
	<div class="asset-picker-v2">
		<header class="asset-picker-v2-header">
			<div class="asset-picker-v2-titles">
				<h2 class="asset-picker-v2-title">{{ "ASSET_PICKER__TITLE" | transloco }}</h2>
				<p class="asset-picker-v2-description">{{ "ASSET_PICKER__DESCRIPTION" | transloco }}</p>
			</div>
			<button
				type="button"
				class="asset-picker-v2-close"
				(click)="close()"
				[attr.aria-label]="'ASSIGNMENT__BUTTON_CANCEL' | transloco"
			>
				<span class="material-symbols-outlined" aria-hidden="true">close</span>
			</button>
		</header>

		<div class="asset-picker-v2-breadcrumb">
			<span>{{ "ASSET_PICKER__BREADCRUMB_START" | transloco }}</span>
			@for (breadcrumb of nodeTree; track breadcrumb.id; let isLast = $last) {
				<span class="asset-picker-v2-breadcrumb-sep">/</span>
				<span [class.asset-picker-v2-breadcrumb-current]="isLast">{{ breadcrumb.name }}</span>
			}
		</div>

		<div class="asset-picker-v2-body">
			@if (nodeTree.length > 1) {
				<button type="button" class="asset-picker-v2-row asset-picker-v2-row--nav" (click)="goBack()">
					<span class="material-symbols-outlined" aria-hidden="true">arrow_back</span>
					<span>{{ "BASE__BACK" | transloco }}</span>
				</button>
			}

			@for (node of currentNode.nodes; track node.id) {
				<div class="asset-picker-v2-item">
					<button type="button" class="asset-picker-v2-row" (click)="onRowClick(node)">
						<span class="material-symbols-outlined" aria-hidden="true">deployed_code</span>
						<span class="asset-picker-v2-row-text">
							<span class="asset-picker-v2-row-name">{{ node.name }}</span>
							@if (node.nodes.length > 0) {
								<span
									class="asset-picker-v2-row-meta"
									[innerHTML]="'ASSET_PICKER__CONTAINS' | transloco: { number: node.nodes.length }"
								></span>
							}
						</span>
					</button>
					<button type="button" class="asset-picker-v2-choose" (click)="choose(node)">
						{{ "ASSET_PICKER__CHOOSE_ASSET" | transloco }}
					</button>
				</div>
			}

			<button type="button" class="asset-picker-v2-row" (click)="noAsset()">
				<span class="material-symbols-outlined" aria-hidden="true">block</span>
				<span>{{ "ASSET_PICKER__NO_ASSET" | transloco }}</span>
			</button>
		</div>

		<footer class="asset-picker-v2-footer">
			<button type="button" class="asset-picker-v2-btn asset-picker-v2-btn--ghost" (click)="close()">
				{{ "ASSIGNMENT__BUTTON_CANCEL" | transloco }}
			</button>
		</footer>
	</div>
} @else {
	<ion-header>
		<ion-toolbar>
			<ion-title>{{ "ASSET_PICKER__TITLE" | transloco }}</ion-title>
			<ion-buttons slot="end">
				<ion-button (click)="close()">
					<ion-icon slot="icon-only" name="close-outline"></ion-icon>
				</ion-button>
			</ion-buttons>
		</ion-toolbar>
	</ion-header>

	<ion-content>
		<ion-text>
			<p class="ion-padding-start ion-padding-end">
				{{ "ASSET_PICKER__DESCRIPTION" | transloco }}
			</p>
		</ion-text>
		<ion-list lines="full">
			<ion-list-header lines="full">
				{{ "ASSET_PICKER__BREADCRUMB_START" | transloco }}
				<span *ngFor="let breadcrumb of nodeTree; last as isLast">
					&nbsp; >
					<span [ngClass]="{ highlight: isLast }">{{ breadcrumb.name }}</span>
				</span>
			</ion-list-header>

			<ion-item button *ngIf="nodeTree.length > 1" (click)="goBack()">
				<ion-icon name="chevron-back-outline" slot="start" color="primary"></ion-icon>
				<ion-label>{{ "BASE__BACK" | transloco }}</ion-label>
			</ion-item>

			<ion-item button *ngFor="let node of currentNode.nodes" lines="full">
				<ion-icon name="cube-outline" slot="start" color="primary"></ion-icon>
				<ion-label (click)="expand(node)">
					{{ node.name }}
					<p
						*ngIf="node.nodes.length > 0"
						innerHTML="{{ 'ASSET_PICKER__CONTAINS' | transloco: { number: node.nodes.length } }}"
					></p>
				</ion-label>
				<ion-button (click)="choose(node)" slot="end">{{ "ASSET_PICKER__CHOOSE_ASSET" | transloco }}</ion-button>
			</ion-item>

			<ion-item button (click)="noAsset()" lines="full">
				<ion-icon name="close-circle-outline" slot="start" color="primary"></ion-icon>
				<ion-label>{{ "ASSET_PICKER__NO_ASSET" | transloco }}</ion-label>
				<ion-button slot="end">{{ "ASSET_PICKER__CHOOSE_ASSET" | transloco }}</ion-button>
			</ion-item>
		</ion-list>
	</ion-content>
}
